import axios from 'axios';

export type WhatsNewStatus = {
	lastSeenAppVersion: string | null;
	lastSeenAppVersionAt: string | null;
};

export const getWhatsNewStatus = async (token: string): Promise<WhatsNewStatus> => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/me/whats-new`;
	const response = await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
	return response.data;
};

export const markWhatsNewSeen = async (token: string, version: string): Promise<void> => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/me/whats-new/seen`;
	await axios.post(
		url,
		{ version },
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};
